import { render } from "./OnboardingSuccessful.vue?vue&type=template&id=6ce9f12c&scoped=true"
import script from "./OnboardingSuccessful.vue?vue&type=script&lang=js"
export * from "./OnboardingSuccessful.vue?vue&type=script&lang=js"

import "./OnboardingSuccessful.vue?vue&type=style&index=0&id=6ce9f12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce9f12c"]])

export default __exports__